export default "__VITE_ASSET__5CZwzLJF__"